export default {
  GLOBAL_SETTINGS_EXTRA_CONFIGS_SAVE: 'global-settings-schedule-tab:save',
  GLOBAL_SETTINGS_TIMESHEET_TAB_SAVE: 'global-settings-timesheet-tab:save',
  GLOBAL_SETTINGS_TIMESHEET_TAB_ERROR: 'global-settings-timesheet-tab:error',
  GLOBAL_SETTINGS_CLOSE: 'global-settings:close',
  GLOBAL_SETTINGS_OPEN: 'global-settings:open',
  GLOBAL_SETTINGS_V2_OPEN: 'global-settings-v2:open',
  SHIFT_PULSE_SETTINGS_OPEN: 'shift-pulse-settings:open',
};
